import { useTranslation } from 'react-i18next'
import {
  CoveragePolicyFolderIcon,
  CoverageStarsIcon,
  CoveragePriceIcon,
} from '@/components/atoms'
import { FEATURE_ICON_CLASS } from '@/shared/constants/icons'

export function useRentersStepSixPage() {
  const { t } = useTranslation()

  const features = [
    {
      icon: <CoveragePriceIcon className={FEATURE_ICON_CLASS} />,
      title: t('onboarding.renters.stepSix.feature1Title'),
      description: t('onboarding.renters.stepSix.feature1Description'),
    },
    {
      icon: <CoverageStarsIcon className={FEATURE_ICON_CLASS} />,
      title: t('onboarding.renters.stepSix.feature2Title'),
      description: t('onboarding.renters.stepSix.feature2Description'),
    },
    {
      icon: <CoveragePolicyFolderIcon className={FEATURE_ICON_CLASS} />,
      title: t('onboarding.renters.stepSix.feature3Title'),
      description: t('onboarding.renters.stepSix.feature3Description'),
    },
  ]

  return { features }
}
